// extracted by mini-css-extract-plugin
module.exports = {"close":"Lightbox_close__HUk3W","backdrop":"Lightbox_backdrop__5vxNq","backdropBlur":"Lightbox_backdropBlur__FmnSQ","wrapper":"Lightbox_wrapper__61dCz"};